<template>
  <el-dialog
    :visible.sync="visible"
    title="撥打備註記錄"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="70%"
  >
    <table-page ref="childTable" @getTableData="getTableData" :pageData="pageData"></table-page>

    <template slot="footer">
      <el-button @click="visible = false">關閉</el-button>
    </template>
  </el-dialog>
</template>

<script>
import tablePage from '@/components/page/table'
import Url from '@/views/analyse/util/url'
import DateUtil from '@/utils/IM/tradeDataUtil.js'

let callTypeArray = { 0: '模拟账号拨打', 1: '真实账号拨打', 2: '手机拨打' }
let connectedList = {
  0: '有效沟通',
  1: '没有接通',
  2: '接通挂线',
  3: '用户正忙',
  4: '空号停机',
  5: '明确表示无意向',
  6: '其他无效沟通',
  7: '异常客户',
  8: '不便接聽',
  9: '非本人注册',
  10: '無需跟進'
}
export default {
  components: {
    tablePage
  },
  data() {
    return {
      visible: false,
      queryData: {},
      tableData: [],
      detailAmount: 0,
      /*table生成*/
      pageData: {
        queryUrl: Url.sleeping.getNoteInfo, //请求路径和参数
        selection: true,
        sequence: true,
        cols: [
          {
            title: '时间', field: 'createTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '操作人', field: 'createUser' },
          {
            title: '分类', field: 'connected', render: (data, full) => {
              return connectedList[data]
            }
          },
          {
            title: '类型', field: 'type', render: (data, full) => {
              return callTypeArray[data]
            }
          },
          {
            title: '备注', field: 'remark'
          }
        ]
      }
    }
  },
  computed: {},

  methods: {
    init(data) {
      console.info(data)
      this.visible = true
      if (data) {
        this.queryData = data
      }
      console.info(this.queryData)
      this.$nextTick(() => {
        if (this.queryData) {
          this.$refs.childTable.defaultGetData(this.queryData)
        }
      })
    },
    getTableData(tableData) {
      this.tableData = tableData
    }
  }
}
</script>
